import type { About } from "@brookbush/types";

import { ChevronRight } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { NextSeo } from "next-seo";
import useSWR from "swr";

const AboutHero = () => {
	const { data: about } = useSWR<About>(`/company-info/about`);

	if (!about) return null;

	return (
		<>
			<NextSeo
				title="About Us"
				description={about.seo.description}
				openGraph={{
					title: "About Us",
					url: `${process.env.NEXT_PUBLIC_SITE_URL}/about`,
					description: about.seo.description,
					images: [
						{
							url: about.image,
							width: 800,
							height: 600,
							alt: "About Us",
						},
					],
				}}
			/>

			<section className="relative mx-auto p-8 sm:h-[93vh] sm:p-28">
				<Image
					src={about.image}
					alt="About Us"
					fill
					priority
					loading="eager"
					className="object-cover"
					quality={75}
				/>
				<div className="absolute inset-0 bg-black/70" />
				<div className="relative flex h-full max-w-5xl flex-col items-start justify-center gap-4 sm:gap-6">
					<h1 className="text-left font-semibold text-3xl text-white md:text-4xl lg:text-6xl">
						{about.heading}
					</h1>
					<p className="text-left text-base text-white md:text-2xl">
						{about.tagline}
					</p>

					<Link
						href="/trial-membership"
						className="mt-2 rounded-full bg-primary-600 px-6 py-2.5 text-white text-xl hover:bg-primary-700"
					>
						7-day Free Trial
						<ChevronRight
							className="-mr-1 inline-block"
							aria-label="Arrow right"
						/>
					</Link>
				</div>
			</section>
		</>
	);
};

export default AboutHero;
